exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-summary[data-v-f08ccb00]{display:flex;flex-direction:column;gap:16px;padding:22px 24px;border:1px solid #e9e3f2;border-radius:10px;background:#fbfafd}.summary-label[data-v-f08ccb00]{margin:0 0 4px;font-size:12px;letter-spacing:.05em;text-transform:uppercase;color:#7a7a7a}.summary-user[data-v-f08ccb00]{display:flex;align-items:center;gap:12px;min-width:0}.summary-avatar[data-v-f08ccb00]{width:44px;height:44px;font-size:15px}.summary-text[data-v-f08ccb00]{min-width:0}.summary-name[data-v-f08ccb00]{font-weight:600;color:#363636;overflow-wrap:anywhere}.summary-email[data-v-f08ccb00]{font-size:12px;color:#7a7a7a;overflow-wrap:anywhere}.summary-value[data-v-f08ccb00]{font-size:14px;color:#363636}.summary-tags[data-v-f08ccb00]{display:flex;flex-wrap:wrap;gap:6px}.summary-note[data-v-f08ccb00]{margin:0;font-size:13px;color:#7a7a7a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f08ccb00","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/users/components/UserSummary.vue
// module id = 2013
// module chunks = 2